<template>
  <div
    class="MarketingChannelOption"
    :class="{'MarketingChannelOption--other': marketingChannel.value === 'other'}">
    <label
      :for="`marketing_channel_${marketingChannel.value}`"
      :title="marketingChannel.name">
      <input
        :id="`marketing_channel_${marketingChannel.value}`"
        :value="marketingChannel.value"
        :checked="selectedMarketingChannels.includes(marketingChannel.value)"
        type="checkbox"
        class="Checkbox"
        @input="onInput">
      <span>
        {{ marketingChannel.name }}
      </span>
    </label>
    <div
      v-if="marketingChannel.value === 'other'"
      class="MarketingChannelOption-otherInput">
      <textarea
        :value="otherMarketingChannel"
        :disabled="!selectedMarketingChannels.includes('other')"
        maxlength="100"
        rows="1"
        @input="onOtherInput"/>
      <span class="CharacterCount">
        {{ otherMarketingChannel.length }}/100
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'marketing-channel-option',
  props: {
    marketingChannel: {
      type: Object,
      required: true
    },
    selectedMarketingChannels: {
      type: Array,
      required: true
    },
    otherMarketingChannel: {
      type: String,
      default: ''
    }
  },
  methods: {
    onInput(event) {
      const value = event.target.value
      const isChecked = event.target.checked
      let updatedChannels = [...this.selectedMarketingChannels]

      if (isChecked) {
        if (!updatedChannels.includes(value)) {
          updatedChannels.push(value)
        }
      } else {
        updatedChannels = updatedChannels.filter(channel => channel !== value)
      }

      this.$emit('input', updatedChannels)
    },
    onOtherInput(event) {
      this.$emit('other-input', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/_shared_variables.sass";
@import "~@/assets/css/_variables.scss";

.MarketingChannelOption {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: $space-xs;
  padding-right: $space-xs;
  margin-bottom: $space-l;
  gap: $space-s;

  &:last-child {
    margin-bottom: 0;
  }

  label {
    display: flex;
    align-items: center;
    width: auto;
    height: 100%;
    cursor: pointer;
    word-break: break-word;

    @media (max-width: 767px) {
      width: 100%;
    }

    input {
      position: absolute;
      margin: 1px 0 0;
    }

    span {
      display: inline-block;
      padding-left: $space-l;
      vertical-align: top;
    }
  }

  &--other {
    flex-wrap: nowrap;
    gap: $space-m;
    align-items: center;
    height: 19px;

    label {
      flex: 0 0 auto;
      max-width: none;
      height: auto;
    }

    @media (max-width: 767px) {
      flex-wrap: wrap;
      gap: $space-s;
      height: auto;

      label {
        flex-basis: 100%;
        max-width: 100%;
      }

      .MarketingChannelOption-otherInput {
        flex-basis: 100%;
        max-width: 100%;
        height: auto;
        margin-top: $space-xs;
      }
    }
  }

  &-otherInput {
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: $space-xxs;
    width: 40vw;
    max-width: 450px;
    height: 19px;

    textarea {
      width: 100%;
      height: 19px;
      padding: 2px $space-xxs 6px $space-xxs;
      border: 1px solid $gray-light;
      border-radius: $global-radius;
      resize: none;
      font-family: $font-family;
      font-size: $font-size-h6;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      box-sizing: border-box;
      scrollbar-width: none;

      &:disabled {
        background: $gray-lightest;
        cursor: not-allowed;
      }

      &:focus {
        outline: none;
        border-color: $color-brand;
        box-shadow: 0 0 0 1px $color-brand;
        background-color: $white;
      }
    }

    .CharacterCount {
      flex: 0 0 auto;
      color: $gray-dark;
      font-size: $font-size-p;
      white-space: nowrap;
      line-height: 19px;
    }

    @media (max-width: 767px) {
      flex-wrap: wrap;
      width: 100%;
      max-width: 100%;
      height: auto;

      textarea {
        max-width: 100%;
        height: auto;
      }

      .CharacterCount {
        width: 100%;
        text-align: right;
        line-height: inherit;
        margin-top: $space-xxs;
      }
    }
  }
}
</style>
